// Generated by ice/scripts/listTenants.ts — do not edit by hand.

export const DEVELOPMENT_AUTH_TENANTS = [
  'aaa-duplicazione-aut-kk4ka',
  'aaa-pianidibobbio-du-kdlrk',
  'aaa-test-zzz-l27pe',
  'adamello-ski-ecvxy',
  'cervino-ski-paradise-78cr4',
  'livignonameauth-nd1wu',
  'pianidibobbio-v26iu',
  'test-mfa-5if3p',
] as const;

export const PRODUCTION_AUTH_TENANTS = [
  'beneficy-5hmwl',
  'beneficy-bikeit-8jzkj',
  'beneficy-discovera-je12c',
  'beneficy-snowit-ur4mr',
  'bikeit-07z40',
  'bolonice-7eqoe',
  'cervinia-871zh',
  'cervinia-b2b-mrdv9',
  'ciclista-6q1j7',
  'cortina-k1bg2',
  'giteintreno-bayhv',
  'jointly-37g6e',
  'jointly-discovera-4lwpn',
  'mdc-agenzie-w2bx4',
  'mdc-b2b-dw5uk',
  'mdc-cambiomerce-yv9oc',
  'mdc-users-69kyj',
  'paganella-jv7vx',
  'skipasslombardia-m534s',
  'tantosvago-2bthz',
  'tantosvago-bikeit-x9jna',
  'tantosvago-tribala-cqei8',
  'tribala-3cxxd',
  'unipol-oex4t',
  'universitybox-qhxjc',
  'viageo-k3md8',
] as const;

export const AUTH_TENANTS_BY_ENV = {
  development: DEVELOPMENT_AUTH_TENANTS,
  production: PRODUCTION_AUTH_TENANTS,
} as const;
